import type { DateISO } from "~/types";
import { MAX_FILE_SIZE } from "~/helpers/media";
import {
  required,
  atLeastOne,
  emailRule,
  fileSizeRule,
  imageTypeRule,
  minDateRule,
  maxDateRule
} from "~/helpers/form-validation";

export default function useValidation() {
  const { tt } = useLocalization();

  return {
    required(v: string | number) {
      return required(v) || tt('rules.required');
    },
    atLeastOne(arr: any[]) {
      return atLeastOne(arr) || tt('rules.one_min');
    },
    emailRule(v: string) {
      return emailRule(v) || tt('rules.email_invalid');
    },
    fileSizeRule(v: File, max = MAX_FILE_SIZE) {
      return fileSizeRule(v) || tt('rules.file_size', { max });
    },
    imageTypeRule(v: File | null) {
      return imageTypeRule(v) || tt('rules.file_not_supported');
    },
    minDateRule(min: Date, v: DateISO) {
      return minDateRule(min, v) || tt('rules.too_early');
    },
    maxDateRule(max: Date, v: DateISO) {
      return maxDateRule(max, v) || tt('rules.too_late');
    }
  };
}